import { DateTime, WeekdayNumbers } from 'luxon';
import { arrayUniqueFormatter } from '@wwe-portal/web/utils/forrmatters/formatters.util';
import { OfferData } from '@wwe-portal/entities/offer.type';
export const getDailyOfferAvailableDays = (schedules) => {
  if (schedules?.length) {
    const availableWeekDays = [] as string[];
    schedules.forEach((schedule) => {
      if (typeof schedule[0] === 'string') {
        const day = DateTime.fromJSDate(new Date(schedule[0])).weekday;
        const weekDayShort = DateTime.fromObject({
          weekday: day as WeekdayNumbers,
        }).toFormat('ccc');

        availableWeekDays.push(weekDayShort);
      }
    });

    return arrayUniqueFormatter(availableWeekDays).join(', ');
  }

  return '';
};

export const sortDailyWebCoinOffers = (offers: OfferData[]) => {
  if (!offers) return [];

  return offers.sort((a, b) => {
    const aDay = a.StartDate
      ? DateTime.fromJSDate(new Date(a.StartDate)).weekday
      : 0;
    const bDay = b.StartDate
      ? DateTime.fromJSDate(new Date(b.StartDate)).weekday
      : 0;

    if (aDay < bDay) {
      return -1;
    }

    if (aDay > bDay) {
      return 1;
    }

    if (aDay === bDay) {
      if (
        a.Price &&
        b.Price &&
        a.defaultCurrency &&
        b.defaultCurrency &&
        a.Price?.[a.defaultCurrency] &&
        b.Price?.[b.defaultCurrency]
      ) {
        if (
          (a.Price?.[a.defaultCurrency] ?? 0) <
          (b.Price?.[b.defaultCurrency] ?? 0)
        ) {
          return -1;
        }

        if (
          (a.Price?.[a.defaultCurrency] ?? 0) <
          (b.Price?.[b.defaultCurrency] ?? 0)
        ) {
          return 1;
        }
      }
    }

    return 0;
  });
};
